
var productid = $('#product-builder').attr("data-product-id");
var redirectUrl = 'pages/bundle-and-save';

if (productid == '4509159096400') {
  console.log("found the product");

  $('.cpb-add-to-cart-button').click(function () {
    preventdefault();
    window.location.href = redirectUrl;
    return false;
    
  });
  
}

console.log(productid);
